<template>
  <main>
    <a @click.prevent="$router.go(-1)" href="#" class="link-back"><span class="icon-ico-arrow-left"></span> Internal
      Issue</a>
    <FormInternalIssue v-model="data" @submit="onSubmit" ref="formInternalIssue" />
  </main>
</template>
<script>
import FormInternalIssue from "@/components/form/feedback/internal-issue"
import axios from '@/axios';
import { showErrorMessage } from '@/utils';
import structuredClone from 'core-js/actual/structured-clone';
import { objectToFormData } from '@/utils/formdata';

export default {
  components: {
    FormInternalIssue
  },
  data() {
    return {
      data: {
        distribute_to: 'QA/QC',
        date: '',
        root_couse: '',
        preventive_action: '',
        corrective_action: '',
        description: '',
        photos: [],
        prepared_by: ''
      },
    }
  },
  computed: {
    AppActiveUser() { return this.$store.state.AppActiveUser },
    detail() {
      return this.$store.state?.feedbackComplaint?.detail
    },
  },
  created() {
    this.data.prepared_by = this.AppActiveUser?.name
    if (this.$route.name === 'FeedbackFormEditInternalIssue') {
      this.getDetail()
    }
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.formInternalIssue.$validator.validateAll();
      if (isValid) {
        try {
          this.$store.dispatch('toggleLoadingProgress', true)
          const _cloneData = structuredClone({
            ...this.data,
            distribute_to: 'QA/QC',
          });
          delete _cloneData.prepared_by

          const data = objectToFormData(_cloneData);
          await axios.post(`/fnc-internal-issues/${this.$route.params.id}`, data, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          })
          this.$notify({ type: 'success', text: 'Success updating internal issue' })
          this.$router.push(`/feedback/${this.$route.params.id}`)
        } catch (error) {
          showErrorMessage(error)
        } finally {
          this.$store.dispatch('toggleLoadingProgress', false)
        }
      }
    },

    async getDetail() {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        const response = await axios.get(`/fnc-internal-issues/${this.$route.params.id}`)
        if (response.status == 200) {
          const { data } = response?.data
          this.data = {
            distribute_to: 'QA/QC',
            date: data?.date,
            root_couse: data?.root_couse,
            preventive_action: data?.preventive_action,
            corrective_action: data?.corrective_action,
            description: data?.description,
            photos: data?.photos,
            prepared_by: data?.qc_detail?.name
          }
        }
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    }
  },
  watch: {
    $route: {
      async handler() {
        if (this.$route.name !== 'FeedbackFormEditInternalIssue') {
          await this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
          this.data.description = this.detail?.description
        }
      }, immediate: true
    }
  }
}
</script>

<style></style>
